/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_preview_alert_admin_action23 = /** @type {(inputs: {}) => string} */ () => {
	return `If you would like to share this resource with everyone, you can publish this item in the Builder using the link below.`
};

const fr_preview_alert_admin_action23 = /** @type {(inputs: {}) => string} */ () => {
	return `Si vous souhaitez partager cette ressource avec tout le monde, vous pouvez publier cet élément dans le Builder en utilisant le lien ci-dessous.`
};

const de_preview_alert_admin_action23 = /** @type {(inputs: {}) => string} */ () => {
	return `Wenn Sie diese Ressource mit allen teilen möchten, können Sie diesen Artikel über den unten stehenden Link im Builder veröffentlichen.`
};

const es_preview_alert_admin_action23 = /** @type {(inputs: {}) => string} */ () => {
	return `Si desea compartir este recurso con todos, puede publicarlo en el Generador utilizando el siguiente enlace.`
};

const it_preview_alert_admin_action23 = /** @type {(inputs: {}) => string} */ () => {
	return `Se desideri condividere questa raccolta con tutti, puoi pubblicare questo elemento nel Builder utilizzando il link sottostante.`
};

const ar_preview_alert_admin_action23 = /** @type {(inputs: {}) => string} */ () => {
	return `إذا كنت ترغب في مشاركة هذه المجموعة مع الجميع، يمكنك نشر هذا العنصر في Builder باستخدام الرابط أدناه.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const preview_alert_admin_action23 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.preview_alert_admin_action23(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("preview_alert_admin_action23", locale)
	if (locale === "en") return en_preview_alert_admin_action23(inputs)
	if (locale === "fr") return fr_preview_alert_admin_action23(inputs)
	if (locale === "de") return de_preview_alert_admin_action23(inputs)
	if (locale === "es") return es_preview_alert_admin_action23(inputs)
	if (locale === "it") return it_preview_alert_admin_action23(inputs)
	return ar_preview_alert_admin_action23(inputs)
};
export { preview_alert_admin_action23 as "PREVIEW_ALERT_ADMIN_ACTION" }